import { apiClient } from '@/shared/api/api.client'

// ─── Type definitions ───────────────────────────────────────────────────────

export interface ProviderRecord {
	providerId: string
	name: string
	code: string
	description?: string
	logoUrl?: string
	isActive: boolean
	ownerId?: string | null
	lifecycleStatus: string
	dataClassification?: string[]
	businessImpact: string
	riskLevel: string
	metadata?: Record<string, unknown>
	createdAt: string
	updatedAt: string
	deletedAt: string | null
}

export interface ProviderFormData {
	name: string
	code: string
	description?: string
	logoUrl?: string
	isActive?: boolean
	ownerId?: string
	/** UI-only display name for the owner autocomplete. Stripped from the wire payload by `createProvider` / `updateProvider`. */
	ownerDisplayName?: string
	lifecycleStatus?: string
	dataClassification?: string[]
	businessImpact?: string
	riskLevel?: string
	metadata?: Record<string, unknown>
}

// ─── API surface ────────────────────────────────────────────────────────────

export const providersApi = {
	list: async (): Promise<ProviderRecord[]> => {
		const response = await apiClient.get<ProviderRecord[]>('/providers')
		return response.data || []
	},
	get: async (providerId: string): Promise<ProviderRecord> => {
		const response = await apiClient.get<ProviderRecord>(`/providers/${providerId}`)
		return response.data
	},
	create: async (data: ProviderFormData): Promise<ProviderRecord> => {
		const { ownerDisplayName: _, ...payload } = data
		const response = await apiClient.post<ProviderRecord>('/providers', payload)
		return response.data
	},
	update: async ({ id, data }: { id: string; data: Partial<ProviderFormData> }): Promise<ProviderRecord> => {
		const { ownerDisplayName: _, ...payload } = data
		const response = await apiClient.put<ProviderRecord>(`/providers/${id}`, payload)
		return response.data
	},
	delete: async (id: string): Promise<void> => {
		await apiClient.delete(`/providers/${id}`)
	},
}
